var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import intercom from "@irati/utils/intercom";
import { FormattedMessage } from "@irati/utils/lang";
import { MarginLeftPara } from "../shared";
var LiveChat = /** @class */ (function (_super) {
    __extends(LiveChat, _super);
    function LiveChat() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function () {
            intercom.show();
        };
        return _this;
    }
    LiveChat.prototype.render = function () {
        return (React.createElement(MarginLeftPara, { blue: true, large: true, onClick: this.handleClick },
            React.createElement(FormattedMessage, { id: "medical.landing.contactCard.liveChat" })));
    };
    return LiveChat;
}(PureComponent));
export default LiveChat;
